(ns client-portal.client.oasys.views
  (:require [client-portal.client.layout :as l]
            [client-portal.client.oasys.data]
            [client-portal.client.voice-insights.empty-state :as empty-state]
            [shared.core.reactive :as re]
            [shared.core.style :as style]))

(defn root [_]
  (let [assistant- (re/subscribe [:oasys/selected-assistant-])]
    (fn [args]
      [l/logged-in-with-header-nav-core
       (merge args {:concept-dropdown? false
                    :location-dropdown? false
                    :crew-type-radio? false
                    :timeframe-dropdown? false
                    :assistant-dropdown? true
                    :concept-required? false})
       [l/standard-content-container {:title "Assistant View"}
        (if-let [{:keys [id label]} @assistant-]
          [:div {:style {:display :flex
                         :flex-direction :column
                         :gap 4}}
           [:span {:style {:color (style/alc-color "Text/primary_header")
                           :font-size 18}}
            label]
           [:span {:style {:color (style/alc-color "Text/secondary")
                           :font-size 14}}
            id]]
          [empty-state/no-data-card {:text "No Assistant Selected"
                                     :material-icon-type :hub}])]])))
